import * as React from 'react';

// tslint:disable:max-line-length
export const SportsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4.7 11.8h-2l-.6 1.9c-1.4.5-2.9.5-4.3 0l-.6-1.9h-2C2.4 10.7 1.9 9.3 2 7.7l1.6-1.1L3 4.7c.8-1.2 2-2.1 3.5-2.5L8 3.4l1.6-1.2c1.4.4 2.6 1.3 3.4 2.5l-.6 1.9L14 7.7c.1 1.6-.4 3-1.3 4.1z" />
      <path d="M5.5 7.4l1.2 2.5h2.6l1.2-2.5L8 5.5z" />
    </g>
  </svg>
);
